import Hoc from "./Hoc";
import Delayed from "../../atoms/deleyad";
import SystemModel from "../../molecules/bluePrintComponents/SystemModel";
import Skeleton from "@material-ui/lab/Skeleton";
import BluePrintBuilder from "./Builder";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onRefresh } from "../../../store/blueprint/actions";
import { makeStyles } from "@material-ui/core/styles";
import { getBlueprintLoading, getLogHelpers, getSimulationRunStatus, getValidatorStatus } from "../../../store/global/selectors";
import RightDrawer from './RightDrawer';
import Transaction from './Transaction';
import Views from "../../molecules/dashboardBuilder";
import ManageAssets from '../../molecules/assets/ManageAssets';
import Teams from '../../molecules/teams';
import Simulation from '../../molecules/simulations';
import { handleTopRightInfo, invokeGetService, toggleSimulationRun, toggleValidator } from "../../../store/global/actions";
import config from "../../../config";
import { Helmet } from "react-helmet";
import PlatformSchema from "../../molecules/platformSchema";
import useSocket from "../../../hooks/useSocket";
import { connectSocket, disconnectSocket } from "../../../websocket/socketProvider";
import socket from "../../../websocket";
import { EVENTS } from "../../../websocket/events";
import { getDetailsFromUrl } from "../../../services/blueprint";
import LogsFab from "../../molecules/logs/LogsFab";
import LogsModal from "../../molecules/logs/LogModal";

const useStyles = makeStyles((theme) => ({
	appBarSpacer: theme.mixins.toolbar,
}));
const onbeforeundload = function () {
	return "Data will be lost if you leave the page, are you sure?";
};

const BuilderPage = (props) => {
	const {blueprintId} = getDetailsFromUrl()
	const simulationRunning = useSelector(getSimulationRunStatus)
	const validatorStatus = useSelector(getValidatorStatus)

	const logMap = useSelector(getLogHelpers)
	const [isLogModal, setLogModal] = useState(false)
	const [logsCount, setLogsCount] = useState({})

	const onLogModalClose = () => {
		setLogModal(false);
		dispatch(toggleSimulationRun(false))
		dispatch(toggleValidator(false))
	}

	const showLogFab = true;

	useEffect(() => {
		if(simulationRunning) setLogModal(simulationRunning)
	},[simulationRunning])

	useEffect(() => {
		dispatch(handleTopRightInfo({ open: false }));
		dispatch && dispatch(onRefresh());
		window.onbeforeunload = onbeforeundload;
		getDockPosition()
		return () => {
			window.onbeforeunload = null;
		};
	}, []);


	useEffect(() => {
		const joinBlueprint = () => {
			socket.emit(EVENTS.JOIN_BLUEPRINT, {
				blueprintId,
				logMap
			});
		};
	
		socket.on("connect", joinBlueprint);
	
		if (socket.connected) {
			joinBlueprint();
		}
	
		return () => {
			socket.off("connect", joinBlueprint);
	
			if (socket.connected) {
				socket.emit(EVENTS.LEAVE_BLUEPRINT, {
					blueprintId
				});
			}
		};
	}, [blueprintId]);


	useEffect(() => {
		if(socket.connected){
			socket.emit(EVENTS.UPDATE_LOG_MAP, {
				blueprintId,
				logMap
			})
		}
	},[logMap])

	useEffect(() => {
		if(validatorStatus){
			setLogModal(true);
		}
	},[validatorStatus])

	const dispatch = useDispatch();

	async function getDockPosition(){
		const result = await dispatch(invokeGetService('dockPosition'))
		if(result.status){
			console.log(result.data)
			localStorage.setItem('BOTTOM_DRAWER_DOCK', result?.data?.dockPosition)
		}
	}
	const isBlueprintLoading = useSelector(getBlueprintLoading);

	// const toggleView = () => setEditView();
	if (isBlueprintLoading) {
		return (
			<Skeleton variant="rect" animation="wave">
				<SystemModel />
			</Skeleton>
		);
	}

	const { params = {} } = props;

	let component = <Fragment />;
	let pageTitle = "Blueprint";

	if (params.tag === "system-model") {
		pageTitle = "System Model";
		component = <SystemModel />;
	}else if (params.tag === "transaction"){
		pageTitle = "Transaction";
		component = <Transaction /*toggleView={toggleView}*/ />;
	}else if (params.tag === 'view'){
		pageTitle = "View";
		component = <Views />

	}else if (params.tag === 'assets'){
		pageTitle = "Assets";
		component = <ManageAssets />

	}else if (params.tag === 'teams'){
		pageTitle = "Team";
		component = <Teams />
		//TODO: Change tag name
	}else if (params.tag === 'testsuite'){
		pageTitle = "Simulation";
		component = <Simulation />
	}else if (params.tag === 'platform-schema'){
		pageTitle = "Platform Schema";
		component = <PlatformSchema />
	}else
		component = <BluePrintBuilder elementTag={params.tag} /*toggleView={toggleView}*/ />;

	return (

		<Fragment>
				<Helmet>
		 			<title>{` ${pageTitle}  | ${config.appName}`}</title>
		 		</Helmet>
				<RightDrawer />
				{
					showLogFab &&
					<LogsFab counts={logsCount} onClick={() => setLogModal(true)}/>
				}
				<LogsModal 
					logMap={logMap} 
					isSimulationRunning={simulationRunning} 
					setLogsCount={setLogsCount} open={isLogModal} 
					onClose={onLogModalClose}
					validatorStatus={validatorStatus}
				/>
				<Delayed dependency={[params.tag]}>{component}</Delayed>
		</Fragment>
	);
};

	export default Hoc(BuilderPage);

